import BookingService from '../../services/BookingService'
import ProfessionalService from '../../services/ProfessionalService'
import SpecialtyService from '../../services/SpecialtyService'
import CompanyService from '../../services/CompanyService'
import TenantService from '../../services/TenantService'
import MedicalInsuranceService from '../../services/MedicalInsuranceService'

import { buildByDate, buildByDateWithHorarios, buildFullDaysOrNotAvaible, sortAttendances } from './builders/attendance'
import { sortProfessionals, unpackProfessionalsFromTenant } from './builders/professional'

export function fetchMedicalInsurances ({ getters, commit }) {
  return new Promise((resolve, reject) => {
    let request
    if (getters.tenant) {
      const professionalRaw = getters.professional
      const professional = professionalRaw ? professionalRaw.split('_')[1] : null
      request = professional
        ? MedicalInsuranceService.findByProfessional(getters.tenant, professional)
        : MedicalInsuranceService.findAllByTenant(getters.tenant)
    } else {
      request = MedicalInsuranceService.findAll()
    }

    request.then(response => {
      if (response.status == 204) {
        commit('setMedicalInsurances', null)
        return resolve()
      }
      commit('setMedicalInsurances', response.data)
      resolve()
    }).catch(e => {
      commit('setMedicalInsurances', null)
      reject(e)
    })
  })
}

export function fetchCompanies ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    const filter = getters.location ? getters.location : null;

    TenantService.findAllPublicDetails(filter)
      .then(response => {
        commit('setCompanies', response.data)
        resolve()
      }).catch(e => {
        commit('setCompanies', null)
        reject(e)
      })
  })
}

export function fetchCompany ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    if (!getters.tenant)
      return reject("tenant must be provided !")

    CompanyService.find(getters.tenant)
      .then(response => {
        commit('setCompany', response.data)
        resolve()
      }).catch(e => {
        commit('setCompany', null)
        reject(e)
      })
  })
}

export function fetchProfessionals ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    const tenant = getters.tenant ? getters.tenant : null;

    ProfessionalService.findAll(tenant, {
      convenioMedico: getters.medicalInsurance ? getters.medicalInsurance : null,
      telemedicina: getters.isTelemedicina ? true : null
    }).then(response => {

      if (response.status == 204) {
        commit('setProfessionals', null)
        return resolve()
      }

      let professionals = response.data
      const unpackedProfessionals = unpackProfessionalsFromTenant(professionals)
      commit('setProfessionals', sortProfessionals(unpackedProfessionals))
      resolve()
    }).catch(e => {

      commit('setProfessionals', null)
      reject(e)
    })
  })
}

export function fetchSpecialties ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    SpecialtyService.findAll()
      .then(response => {
        const result = response.data
        result.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
        commit('setSpecialties', result)
        resolve()
      }).catch(e => {
        commit('setSpecialties', null)
        reject(e)
      })

  })
}

export function fetchAttendances ({ getters, commit, rootState }, { date }) {
  return new Promise((resolve, reject) => {

    const professional = getters.professional ? getters.professional.split("_")[1] : null

    const telemedicina = getters.isTelemedicina || rootState.sgh?.telehealth === true

    BookingService.findHorarios(
      getters.tenant,
      getters.location,
      date,
      professional,
      getters.medicalInsurance,
      getters.specialty,
      telemedicina
    )
      .then(response => {
        if (response.status == 204) {
          commit('setAttendances', null)
          commit('setFullDaysOrNotAvaible', null)
          return resolve()
        }

        let attendances = response.data || []

        // normaliza telehealth em cada atendimento e em cada horario
        const normalized = attendances.map(prof => {
          if (prof.atendimentos && Array.isArray(prof.atendimentos)) {
            return {
              ...prof,
              atendimentos: prof.atendimentos.map(at => ({
                ...at,
                telehealth: at.telehealth === true || at.telemedicina === true || at.attendance === 'telemedicina',
                horariosDisponiveis: (at.horariosDisponiveis || []).map(hd => ({
                  ...hd,
                  telehealth: at.telehealth === true || at.telemedicina === true
                })),
                horarios: at.horarios || at.horariosDisponiveis || []
              }))
            }
          }
          return { ...prof, telehealth: prof.telehealth === true }
        })

        const attendancesGroupedByDate = buildByDate(normalized)
        const sortedGrouped = sortAttendances(buildByDateWithHorarios(attendancesGroupedByDate))

        // normaliza/propaga telehealth e garante objeto keyed por data no state
        const ensureTelehealth = (groups) => {
          const globalTele = rootState.sgh && (rootState.sgh.telehealth === true || (rootState.sgh.filter && rootState.sgh.filter.attendance === 'telemedicina'))
          const entries = Array.isArray(groups) ? groups.map((g, i) => [i, g]) : Object.entries(groups || {})
          return entries.reduce((result, [dateKey, group]) => {
            result[dateKey] = group.map(item => {
              const anyAtHasTele = (item.atendimentos || []).some(a => a.telehealth === true || a.telemedicina === true || a.attendance === 'telemedicina')
              const itemTele = anyAtHasTele || globalTele
              return {
                ...item,
                telehealth: itemTele,
                atendimentos: (item.atendimentos || []).map(a => {
                  const aTele = a.telehealth === true || a.telemedicina === true || a.attendance === 'telemedicina' || itemTele
                  return {
                    ...a,
                    telehealth: aTele,
                    horarios: a.horarios || a.horariosDisponiveis || [],
                    horariosDisponiveis: (a.horariosDisponiveis || a.horarios || []).map(h => ({ time: h, telehealth: aTele }))
                  }
                })
              }
            })
            return result
          }, {})
        }

        const finalGrouped = ensureTelehealth(sortedGrouped)
        commit('setAttendances', finalGrouped)

        commit('setFullDaysOrNotAvaible', buildFullDaysOrNotAvaible(sortedGrouped))
        resolve()
      }).catch(e => {
        commit('setAttendances', null)
        commit('setFullDaysOrNotAvaible', null)
        reject(e)
      })

  })
}





export function refreshHorarios ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    const selected = getters.selected
    const tenant = getters.tenant || selected?.tenant?.codigo

    if (!tenant)
      return reject("tenant must be provided !")

    BookingService.findHorariosByProfessional(tenant, selected.date, getters.isTelemedicina, selected.professional.codigo, selected.attendance.tempo)
      .then(response => {

        let horarios = response.data
        commit('setHorarios', {
          date: selected.date,
          profissional: selected.professional,
          atendimento: selected.attendance,
          horarios: horarios ? horarios.horarios : [],
        })
        resolve()
      }).catch(e => {
        reject(e)
      })
  })
}

